import * as React from 'react';
import Button from '@material-ui/core/Button';
import FolderIcon from '@mui/icons-material/Folder';

function MyProjects() {
  return (
    <div className="py-4 border-bottom">
      <p className="clearfix">
       <p><strong>My Projects</strong></p>
        <Button
          href={"/my_projects"}
          size="small"
          variant="outlined"
          startIcon={<FolderIcon />}
        >
          View my projects
        </Button>
      </p>
    </div>
  );
}

export default MyProjects;
